import { FilterElementType } from "@utils/DynamicComponentUtils";
import { exposureStatusCheck, RequiredStateCheck, textFormat, upDataAtFormat } from "@utils/TableItemFormattingUtils";
import { type ColDef } from "ag-grid-community";
import { type CommonFilterDataType, type CommonFormType } from "src/types/common";

export type TermsInitialValues = {
    title: string;
    isRequired: boolean | string;
    isVisibleOnSignup: boolean | string;
    isVisibleOnServicePage: boolean | string;
};

export const termsData: CommonFilterDataType<TermsInitialValues, CommonFormType, ColDef> = {
    formInitialValues: {
        title: "",
        isRequired: "",
        isVisibleOnSignup: "",
        isVisibleOnServicePage: "",
    },
    forms: [
        {
            type: FilterElementType.INPUT,
            name: "title",
            label: "약관명",
        },
        {
            type: FilterElementType.SELECT,
            name: "isRequired",
            label: "필수 여부",
            option: [
                { label: "전체", value: "" },
                { label: "필수", value: "true" },
                { label: "선택", value: "false" },
            ],
        },
        {
            type: FilterElementType.SELECT,
            name: "isVisibleOnSignup",
            label: "회원가입 노출",
            option: [
                { label: "전체", value: "" },
                { label: "노출", value: "true" },
                { label: "미노출", value: "false" },
            ],
        },
        {
            type: FilterElementType.SELECT,
            name: "isVisibleOnServicePage",
            label: "서비스 약관 노출",
            option: [
                { label: "전체", value: "" },
                { label: "노출", value: "true" },
                { label: "미노출", value: "false" },
            ],
        },
    ],
    tableList: [
        {
            field: "title",
            headerName: "약관명",
            width: 750,
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "isRequired",
            headerName: "필수 여부",
            maxWidth: 165,
            flex: 1,
            suppressMovable: true,
            cellRenderer: RequiredStateCheck,
        },
        {
            field: "isVisibleOnSignup",
            headerName: "회원가입 노출 상태",
            maxWidth: 165,
            flex: 1,
            suppressMovable: true,
            cellRenderer: exposureStatusCheck,
        },
        {
            field: "isVisibleOnServicePage",
            headerName: "서비스 약관 노출 상태",
            maxWidth: 165,
            flex: 1,
            suppressMovable: true,
            cellRenderer: exposureStatusCheck,
        },
        {
            field: "latestVersionUpdatedAt",
            headerName: "업데이트 일시",
            minWidth: 180,
            maxWidth: 200,
            flex: 1,
            suppressMovable: true,
            cellRenderer: upDataAtFormat,
        },
    ],
};
